export default defineNuxtRouteMiddleware(to => {
    const path = to.path.replace(/\/$/, '');
    if (
        !/^\/sitemap(?:-(?:products|categories|brands|blogs|looks|pages))?\.xml$/.test(path) &&
        !/^\/sitemaps\/[^/]+\.xml$/.test(path)
    ) {
        return;
    }

    // Nitro handles XML before Vue routing. Aborting SSR here cannot hand a request
    // back to Nitro; allow a server error page to render instead.
    if (import.meta.server) return;

    // An XML request can return an HTML error page. Reloading it during hydration
    // would start the same request again indefinitely, masking the original error.
    if (useNuxtApp().isHydrating) return;
    if (window.location.pathname.replace(/\/$/, '') === path) return;

    // Only a client-side navigation from another document needs a full request.
    return navigateTo(path, { external: true });
});
